import { render } from "./ProductHeader.vue?vue&type=template&id=3c03ac9a&scoped=true"
import script from "./ProductHeader.vue?vue&type=script&lang=js"
export * from "./ProductHeader.vue?vue&type=script&lang=js"

import "./ProductHeader.vue?vue&type=style&index=0&id=3c03ac9a&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c03ac9a"]])

export default __exports__